// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"22":"44251d303e7a3f08","572":"b4a3a1a902a4f4af","4611":"17e559fbe60603e6"}[chunkId] + ".css";
};